export const Roles = ["super"];
export const ReportRoles = ["super","admin","traffic_super","traffic_admin"];
export const InvoiceRoles = ["super","finance"];
export const RegistrationRoles = ["super","user","admin"];

// export const changePasswordRoles = ["super","user","admin","finance",];
